/** Dispatch this action to show the app loader which should display when the entire app is loading */
export class ShowAppLoader {
    public static readonly type = '[App] ShowAppLoader';
}

/** Dispatch this action to hide the app loader */
export class HideAppLoader {
    public static readonly type = '[App] HideAppLoader';
}
